<template>
  <ion-text class="text-md font-bold ion-text-brand">Security</ion-text>
  <ion-card class="m-0 p-0 my-3 rounded-xl bg-white" data-cy="security-details">
    <ion-card-content class="p-0">
      <ion-grid class="p-0 m-0">
        <ion-row class="pt-3 pb-2 px-6">
          <ion-col>
            <ion-text class="mb-1 block text-sm ion-text-brand font-bold">Username</ion-text>
            <ion-text class="text-sm mb-1 block ion-text-brand">{{ profile.email_address }}</ion-text>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-card-content>
  </ion-card>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useCustomerStore } from '@/stores';
const customerStore = useCustomerStore();
const { profile } = storeToRefs(customerStore);
</script>